/** @format */

import {IsoDate} from '../types';

// Намеренно UTC-геттеры: date-only ISO-строки парсятся как UTC-полночь, addDays сохраняет
// время суток, поэтому getUTC* возвращает нужную календарную дату в любом часовом поясе.
// Локальные getDate/getMonth сломали бы делитель (WEEKLY=7, MONTHLY=daysInMonth) при отрицательном offset.
export const toIso = (date: Date): IsoDate =>
  `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(
    date.getUTCDate(),
  ).padStart(2, '0')}`;
